import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { COLUMNS_HEADER_USERS_ADMIN } from '../../core/constants/tables.constants';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { UsersService } from '../../core/services/users.service';
import { ROLES } from '../../core/constants/general.constants';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, SpinnerComponent, GenericTableComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_USERS_ADMIN;
  USER_ROLES = ROLES;

  users: any;
  roles: any;

  rolesSelected: string[] = [];

  isModalActive = false;
  isLoading = false;
  isLoadingPage = false;
  isCreating = false;

  faSpinner = faSpinner;

  form: FormGroup = this.formBuilder.group({
    id: [false, Validators.required],
    name: ['', Validators.required],
    username: ['', Validators.required],
    email: ['', Validators.required],
    roles: [['']],
    is_active: [],
  });

  userId: any;

  constructor(
    private formBuilder: FormBuilder,
    private usersSvc: UsersService,
    private toastr: ToastrService
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.getRoles();
    await this.getUsers();
    this.isLoading = false;
  }

  getRoles() {
    this.usersSvc.getRoles().subscribe(res => {
      this.roles = res;
    });
  }



  onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getUsers();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`El usuario ${this.form.value.username} ha sido creado correctamente`);
        } else {
          this.toastr.success(`El usuario ${this.form.value.username} ha sido actualizado correctamente`);
        }
        this.form.reset();
      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
        this.usersSvc.createUser(this.form.value).subscribe(responseAction);
      } else {
        this.usersSvc.updateUser(this.form.value).subscribe(responseAction);
      }
    }
  }

  async getUsers() {
    this.usersSvc.getUsers().subscribe((res: any) => {
      this.users = res;
    });
  }

  openModal(item?: any) {
    if (item) {
      this.userId = item.id;
      this.rolesSelected = [...item.roles];
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
      this.rolesSelected = [];
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  selectRole(role: string) {
    if (!this.rolesSelected.includes(role)) {
      this.rolesSelected.push(role)
    } else {
      const index = this.rolesSelected.findIndex(obj => obj === role);
      this.rolesSelected.splice(index, 1);
    }
    this.form.patchValue({
      roles: this.rolesSelected
    });
  }

}
